import Vue from "vue";
import Router from "vue-router";
import store from "~/store";
import {sync} from "vuex-router-sync";

Vue.use(Router);
//PlacesAdmin
const routes = [
    {
        path: "/route_composer_v_a",
        name: "route_composer_v_a",
        component: require("~/components/Page/ROUTE_COMPOSER/RouteComposerManager")
            .default,
        children: [
            {
                path: "composer_for_day_v_a/:trips",
                name: "composer_for_day_v_a",
                component: require("~/components/Page/ROUTE_COMPOSER/route_composer_v_a").default,
            },

        ],
        meta: {title: "route_composer_v_a", affix: true},
    },
    {
        path: "/route_composer",
        name: "route_composer",
        component: require("~/components/Page/ROUTE_COMPOSER/RouteComposerManager")
            .default,
        children: [
            {
                path: "composer_for_day/:tripTypes/:trips",
                name: "composer_for_day",
                component: require("~/components/Page/ROUTE_COMPOSER/route_composer").default,
            },

        ],
        meta: {title: "route_composer", affix: true},
    },
    {
        path: "/places_admin",
        name: "PlacesAdmin",
        component: require("~/components/Page/SETUP/PlacesAdmin")
            .default,
        meta: {title: "PlacesAdmin", affix: true},
    },
    {
        path: "/waypoints",
        name: "Waypoints",
        component: require("~/components/Page/VEHICLES/WaypointsGear")
            .default,
        meta: {title: "waypoints", affix: true},
    },
    {
        path: "/service_manager/",
        name: "service_manager",
        component: require("~/components/Page/SETUP/ServiceManager")
            .default,
        children: [
            {
                path: ":serviceId",
                name: "service_form",
                component: require("~/components/Page/SETUP/ServiceForm").default,
            },

        ],
        meta: {title: "servise_manager", affix: true},
    },
    {
        path: "/fast_routes/:trips",
        name: "fast_routes",
        component: require("~/components/Page/ROUTE_COMPOSER/FastRouteHandler")
            .default,
        meta: {title: "FastRouteHandler", affix: true},
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: require("~/components/Page/Dashboard").default,
        meta: {title: "Dashboard", affix: true},
    },
    {
        path: "/fleetmanager",
        name: "fleetmanager",
        component: require("~/components/Page/VEHICLES/FleetManager").default,
        meta: {title: "FleetManager", affix: true},
        children: [
            {
                path: "managevehicle/:vehicleid",
                name: "manageVehicle", //for leludi
                component: require("~/components/Page/VEHICLES/VehicleForm").default,
            },

        ],
    },
    {
        path: "/invoices-manager",
        name: "InvoicesManager",
        component: require("~/components/Accounting/Page/InvoicesManager").default,
        meta: {title: "InvoicesManager", affix: true},
    },
    {
        path: "/manage-invoice/:id",
        name: "ManageInvoice",
        component: require("~/components/Accounting/Page/InvoicesManager").default,
        meta: {title: "InvoicesManager", affix: true},
    },
    {
        path: "/timologiera",
        name: "timologiera",
        component: require("~/components/Accounting/Page/Issuer").default,
        meta: {title: "timologiera", affix: true},
    },
    {
        path: "/timologiera/:id",
        name: "timologio",
        component: require("~/components/Accounting/Page/Issuer").default,
        meta: {title: "timologiera", affix: true},
    },
    {
        path: "/simpleacc/:direction/",
        name: "simpletransactions",
        component: require("~/components/Accounting/Page/SimpleTransactionsHandler")
            .default,
        meta: {title: "income", affix: true},

        children: [
            {
                path: "contact/:id",
                name: "flattransview", //for leludi
                component: require("~/components/Accounting/Page/FlatDrafts").default,
            },
            {
                path: "tripTransactions/:id",
                name: "tripTransactions",
                component: require("~/components/Page/TRIPS/ExpensesDrafts").default,
            },
        ],
    },
    {
        path: "/notifications__/:forcedb/o_n/:contactid",
        name: "notifications",
        component: require("~/components/Page/MESSAGING/ContactNotifications").default,
        meta: {title: "timologiera", affix: true},
    },
    {
        path: "/contactpartners/",
        name: "contactpartners",
        component: require("~/components/Page/SETUP/ContactsManager").default,
        meta: {title: "Packages", affix: true},

        children: [
            {
                path: "/contactpartners/:contactid/",
                name: "contactpartner",
                component: require("~/components/Page/SETUP/ContactPartner").default,
                meta: {title: "Tour Company Admin", affix: true},
            },
        ],
    },
    {
        path: "/tourcomanager/",
        name: "tourcomanager",
        component: require("~/components/Page/SETUP/TourCoManager").default,
        meta: {title: "Packages", affix: true},

        children: [
            {
                path: "tourco/:tourcoid/",
                name: "tourco",
                component: require("~/components/Page/SETUP/TourCoForm").default,
                meta: {title: "Tour Company Admin", affix: true},
            },
        ],
    },
    {
        path: "/transactions/:direction/",
        name: "transactions",
        component: require("~/components/Accounting/Page/TransactionsHandler")
            .default,
        meta: {title: "income", affix: true},

        children: [
            {
                path: ":view/:id",
                name: "transview",
                component: require("~/components/Accounting/Page/ContactViewer")
                    .default,
                children: [
                    {
                        path: "trans/:transid",
                        name: "transaction",
                        component: require("~/components/Accounting/Page/ContactViewer")
                            .default,
                    },
                ],
            },
        ],
    },
    {
        path: "/timelineForProducts/:vehicleGroup/",
        name: "timelineForProducts",
        component: require("~/components/Page/TRIPS/RoutesTimeline").default, //
        meta: {title: "RoutesTimeline", affix: true},
        children: [
            {
                path: ":transferBookingId/",
                name: "transferBooking",
                component: require("~/components/Page/BOOKINGS/RouteBookingForm")
                    .default,
                meta: {title: "Package Admin", affix: true},
            },
        ],
    },
    {
        path: "/onlinebooking/",
        name: "onlinebooking",
        component: require("~/components/Page/ONLINE/bookingGate").default,
        meta: {title: "ONLINE BOOKING", affix: true},
    },
    {
        path: "/filearchive/",
        name: "filearchive",
        component: require("~/components/Accounting/Page/FileArchive").default, ///home/halvid/code/kriton/resources/js/components/Accounting/Page/FileArchive.vue
        meta: {title: "ONLINE BOOKING", affix: true},
    },
    {
        path: "/bookservise/:tripServiseId",
        name: "bookServise",
        component: require("~/components/Page/ONLINE/bookingGate").default,
        meta: {title: "ONLINE BOOKING", affix: true},
    },
    {
        path: "/packageamanager/",
        name: "packageamanager",
        component: require("~/components/Page/PACKAGES/PackageManager").default,
        meta: {title: "Packages", affix: true},

        children: [
            {
                path: "package/:packageid/",
                name: "package",
                component: require("~/components/Page/PACKAGES/PackageForm").default,
                meta: {title: "Package Admin", affix: true},
            },
        ],
    },

    {
        path: "/sapplierbookings/",
        name: "sapplierbookings",
        component: require("~/components/Page/SAPPLIERBOOKINGS/ProductLister")
            .default,
        meta: {title: "Excursions", affix: true},

        children: [
            {
                path: "bookings-for-product/:productid/",
                name: "bookingsForProduct",
                component: require("~/components/Page/BOOKINGS/BookingsTable").default,
                meta: {title: "Excursion Admin", affix: true},
            },
        ],
    },

    {
        path: "/filemanager/",
        name: "filemanager",
        component: require("~/components/Page/BOOKINGS/FileManager").default,
        meta: {title: "Excursions", affix: true},

        children: [
            {
                path: "filebookings/:fileid",
                name: "fileBookings",
                props: {viewmode: "filebookings"},
                component: require("~/components/Page/BOOKINGS/LaraTripBookings").default,
                meta: {title: "Bookings", affix: true},
                children: [
                    {
                        path: "filebooking/:bookingid",
                        name: "fileBookingsBooking",
                        props: {viewmode: "filebookings"},
                        component: require("~/components/Page/BOOKINGS/BookingForm")
                            .default,
                        meta: {title: "Bookings", affix: true},
                        // children: [
                        //   {
                        //     path: "tripeditor/:tripid/",
                        //     name: "tripeditor",
                        //     component: require("~/components/Page/SceduleTripForm")
                        //       .default,
                        //     meta: { title: "Excusrion Admin", affix: true }
                        //   }
                        // ]
                    },
                ],
            },
        ],
    },
    {
        path: "/tripsmanager/:kind",
        name: "tripsmanager",
        component: require("~/components/Page/TRIPS/TripsManager").default,
        meta: {title: "Excursions", affix: true},

        children: [
            {
                path: "tripadmin/:tripid/",
                name: "tripadmin",
                component: require("~/components/Page/TRIPS/TripAdmin").default,
                meta: {title: "Excursion Admin", affix: true},
                children: [
                    {
                        path: "configureScheduledTrip/",
                        name: "configureScheduledTrip",
                        component: require("~/components/Page/TRIPS/SceduleTripForm")
                            .default,
                        meta: {title: "Sceduled Trip", affix: true},
                    },

                    {
                        path: "servises/",
                        name: "package_services",
                        props: {viewmode: "package"},
                        component: require("~/components/Page/TRIPS/RoutesTable").default,
                        meta: {title: "Package Servises", affix: true},
                    },
                    {
                        path: "tripacctransactions/",
                        name: "tripACCtransactions",
                        component: require("~/components/Accounting/Page/FlatDrafts")
                            .default,
                        meta: {title: "Transactions", affix: true},
                    },
                    // {
                    //     path: "tripacctransactions/",
                    //     name: "tripACCtransactions",
                    //     component: require("~/components/Page/TRIPS/ScheduledTripDrafts")
                    //         .default,
                    //     meta: {title: "Transactions", affix: true},
                    // },
                    {
                        path: "expenses/",
                        name: "expenses",
                        component: require("~/components/Page/TRIPS/ExpensesDrafts")
                            .default,
                        meta: {title: "Expenses", affix: true},
                    },
                    {
                        path: "tripcosts/",
                        name: "tripcosts",
                        component: require("~/components/Page/TRIPS/TripCosts").default,
                        meta: {title: "Expenses", affix: true},
                    },
                    {
                        path: "bookings/",
                        name: "tripBookings",
                        component: require("~/components/Page/BOOKINGS/TripBookings")
                            .default,
                        meta: {title: "Bookings", affix: true},
                        children: [
                            {
                                path: "booking/:bookingid",
                                name: "tripBookingsBooking",
                                component: require("~/components/Page/BOOKINGS/BookingForm")
                                    .default,
                                meta: {title: "Bookings", affix: true},
                            },
                        ],
                    },
                    {
                        path: "customers/",
                        name: "customers",
                        component: require("~/components/Page/BOOKINGS/CustomerList")
                            .default,
                        meta: {title: "Bookings", affix: true},
                        children: [
                            {
                                path: "customer/:customerid",
                                name: "customer",
                                component: require("~/components/Page/BOOKINGS/CustomerForm")
                                    .default,
                                meta: {title: "Bookings", affix: true},
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        path: "/fuels/",
        name: "fuels",
        component: require("~/components/Page/VEHICLES/Fuels").default,
        meta: {title: "fuels", affix: true},
        children: [
            {
                path: "vehicles",
                name: "vehicles",
                component: require("~/components/Page/VEHICLES/VehicleFuels").default,
                meta: {title: "VehicleFuels", affix: true},
            },
            {
                path: "tanks",
                name: "tanks",
                component: require("~/components/Page/VEHICLES/TankFuels").default,
                meta: {title: "TankFuels", affix: true},
            },
            {
                path: "fuelsrs",
                name: "fuelsrs",
                component: require("~/components/Page/VEHICLES/FuelSrs").default,
                meta: {title: "FuelSrs", affix: true},
            },
        ],
    },
    {
        path: "/estats/",
        name: "explore-stats",
        component: require("~/components/Page/Stats/StatsNavigator").default,
        meta: {title: "StatsNavigator", affix: true},
        children: [

            {
                path: "explorepivot",
                name: "explorePivot",
                component: require("~/components/Page/Stats/Pivot").default,
                meta: {title: "Pivot", affix: true},
            },
        ],
    },
    {
        path: "/accounting/",
        name: "accounting",
        component: require("~/components/Page/StatsNavigator").default,
        meta: {title: "StatsNavigator", affix: true},
        children: [
            {
                path: "incomestats",
                name: "incomestats",
                component: require("~/components/Page/Pivot").default,
                meta: {title: "Pivot", affix: true},
            },
            {
                path: "expensesstats",
                name: "expensesstats",
                component: require("~/components/Page/Pivot").default,
                meta: {title: "Pivot", affix: true},
            },
            {
                path: "pivot",
                name: "pivot",
                component: require("~/components/Page/Pivot").default,
                meta: {title: "Pivot", affix: true},
            },
        ],
    },
    {
        path: "/router",
        name: "busrouter",
        component: require("~/components/Page/VEHICLES/BusRouter").default,
        meta: {title: "Bus Router", affix: true},
    },

    {
        path: "/setup-sappliers",
        name: "setup-sappliers",
        component: require("~/components/Page/SETUP/Sappliers").default,
        meta: {title: "setup-sappliers", affix: true},
    },

    // { path: '/view/:id', name: 'View', component: require('~/components/Page/Update').default ,meta: { title: 'View' }  },
    {path: "*", redirect: "/dashboard"},
];

const router = new Router({
    // mode: 'history',
    scrollBehavior,
    routes,
});
const beforeEach = async (to, from, next) => {
    // await store.restored
    // _log_('auth/beforeEach getLoggedUser', to)
    if (to.name === 'dashboard')
        window.location.replace('/spa3/#/dashboard')
    // if(to.meta.guest && store.getters['auth/loggedIn']) return next('/')
    // // else
    // // _log_(to)
    // if(!to.meta.auth) return next()
    if (!store.state.configuration.loggedUser)
        await store.dispatch('configuration/getLoggedUser')
            .then(() => next())
            .catch(() => next('/'))
    else next()
}
router.beforeEach(beforeEach)
sync(store, router);

export default router;

/**
 * Scroll Behavior
 *
 * @link https://router.vuejs.org/en/advanced/scroll-behavior.html
 *
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition;
    }

    if (to.hash) {
        return {selector: to.hash};
    }

    const [component] = router.getMatchedComponents({...to})
        .slice(-1);

    if (component && component.scrollToTop === false) {
        return {};
    }

    return {x: 0, y: 0};
}
